import { Text } from '../../common/designs'
import { formatTimestamp, getCurrentFormattedTime } from '../../common/utils/dataIntegrationUtils'
import { type ExportStatsResponse, StatusMessageType } from './types'

export const StatisticCard = ({ label, value }: { label: string; value: string | number }) => {
  return (
    <div className='space-y-1'>
      <Text size='s' color='lightGray'>
        {label}
      </Text>
      <Text size='m' weight={500}>
        {value}
      </Text>
    </div>
  )
}

export const ExportStatistics = ({ stats }: { stats: ExportStatsResponse }) => {
  return (
    <div className='space-y-3 rounded-lg border border-gray-200 bg-white p-4'>
      <Text size='m' weight={500}>
        Export Statistics
      </Text>

      <div className='grid grid-cols-1 gap-4 md:grid-cols-2'>
        <StatisticCard
          label='Process Identifier Name'
          value={stats.process_identifier_name ?? 'N/A'}
        />

        <StatisticCard label='Last Updated' value={getCurrentFormattedTime()} />

        <StatisticCard
          label='Total Transactions'
          value={stats.total_transactions?.toLocaleString() ?? '0'}
        />

        <StatisticCard label='Total Events' value={stats.total_events?.toLocaleString() ?? '0'} />

        <StatisticCard
          label='First Timestamp'
          value={stats.first_timestamp ? formatTimestamp(stats.first_timestamp) : 'N/A'}
        />

        <StatisticCard
          label='Last Timestamp'
          value={stats.last_timestamp ? formatTimestamp(stats.last_timestamp) : 'N/A'}
        />
      </div>
    </div>
  )
}

export const StatusMessage = ({ type, message }: { type: StatusMessageType; message: string }) => {
  const getStyles = () => {
    switch (type) {
      case StatusMessageType.LOADING:
      case StatusMessageType.INFO:
        return 'border-gray-200 bg-gray-50'

      case StatusMessageType.ERROR:
        return 'border-red-200 bg-red-50'

      case StatusMessageType.SUCCESS:
        return 'border-green-200 bg-green-50'

      default:
        return 'border-gray-200 bg-gray-50'
    }
  }

  const getTextColor = () => {
    switch (type) {
      case StatusMessageType.LOADING:
      case StatusMessageType.INFO:
        return 'lightGray' as const

      case StatusMessageType.ERROR:
        return 'error' as const

      case StatusMessageType.SUCCESS:
        return 'lightGray' as const

      default:
        return 'lightGray' as const
    }
  }

  return (
    <div className={`rounded-lg border p-4 ${getStyles()}`}>
      <Text color={getTextColor()} size='s'>
        {message}
      </Text>
    </div>
  )
}

